import * as React from 'react';
export const TMSvg = React.forwardRef(function TMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#159570',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M10.636 3.205c0 .75-.606 1.36-1.356 1.363.292.221.649.341 1.015.342a1.705 1.705 0 1 0 0-3.41c-.382 0-.73.13-1.015.342.75.004 1.356.613 1.356 1.363ZM7 4a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm1-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M2 0h4v12H2V0Zm2 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      }),
    ),
  );
});
TMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TM = {
  category: 'flag',
  colorable: false,
  name: 'TM',
  svg: TMSvg,
};
